export function extractApiMessage(payloadOrError) {
  if (typeof payloadOrError === 'string') {
    return payloadOrError;
  }

  const payload = payloadOrError?.response?.data ?? payloadOrError?.data ?? payloadOrError;

  if (!payload) {
    return '';
  }

  if (typeof payload === 'string') {
    return payload;
  }

  if (typeof payload.message_key === 'string') {
    return payload.message_key;
  }

  if (typeof payload.messageKey === 'string') {
    return payload.messageKey;
  }

  if (typeof payload.message === 'string') {
    return payload.message;
  }

  return '';
}
